/*
  Referências:
  - https://developer.mozilla.org/en-US/docs/Web/API/btoa#unicode_strings
  - https://developer.mozilla.org/en-US/docs/Glossary/Base64
  - https://stackoverflow.com/a/30106551
*/

function encode(txt: string) {
  const escapedText: string = encodeURIComponent(txt)
    .replace(
      /%([0-9A-F]{2})/g,
      (match, hex) => String.fromCharCode(parseInt(hex, 16)),
    );

  return btoa(escapedText);
}

function decode(txt: string) {
  const unescapedText = atob(txt)
    .split('')
    .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
    .join('');

  return decodeURIComponent(unescapedText);
}

export default { encode, decode };
